<template>
  <div class="shopsetting">
    <cube-page title="导游" :backurl="'/my'">
      <div slot="content">
        <div class="setting-shop" :style="{ background: `linear-gradient(${gcfg.BackgroundColor} 50%,#FFF)` }">
          <div class="shop-xx shop-setting" v-if="guideData != null"
            :style="'background-color:' + gcfg.BackgroundColor">
            <div class="shop-tx">
              <img :src="guideData.avatar_url">
            </div>
            <div class="shop-xq-a" :style="'color:#545659'">
              <div class="shop-name">
                <p class="name-p">
                  <span class="name ells2">{{ guideData.nickname }}</span>
                </p>
                <p class="name">
                  <span class="name ells2">ID:{{ guideData.id }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="shop-xx shop-setting" v-else :style="'background-color:' + gcfg.BackgroundColor">
            <div class="shop-tx">
            </div>
          </div>
        </div>
        <div class="leoshop-content">
          <van-grid :style="'color:' + gcfg.TopTextColor" clickable :column-num="3" :border="false">
            <van-grid-item @click="gotoTravel" style="color: red;">
              <span v-if="TourNum" class="badge">{{ TourNum }}</span>
              <van-icon name="flower-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" style="font-weight: 600; color: red;">接单开团</span>
            </van-grid-item>
            <van-grid-item @click="goOrder('0')">
              <van-icon name="records" class="van-grid-item__icon" />
              <span class="van-grid-item__text" style="font-weight: 600;">我的订单</span>
            </van-grid-item>
            <van-grid-item @click="goSettingPage">
              <van-icon name="setting-o" class="van-grid-item__icon" />
              <span class="van-grid-item__text" style="font-weight: 600;">设置</span>
            </van-grid-item>
          </van-grid>
        </div>
        <van-list v-model="loading" :immediate-check="false">
          <div class="orderitem van-clearfix" v-for="(item, index) in OrderList" :key="index">
            <div class="ordertitle">
              <p>团队名称：{{ item.team_name }}</p>
              <p class="colorred">
                <span>{{ item.status_text }}</span>
              </p>
            </div>
            <van-card :num="1">
              <template #price-top>
                <div class="carflex">
                  <div class="carddesc">
                    <span>出团时间：</span>
                    <span>{{ item.start_time }}</span>
                  </div>
                  <div class="carddesc">
                    <span>完团时间：</span>
                    <span>{{ item.end_time }}</span>
                  </div>
                  <div class="carddesc">
                    <span>类型：</span>
                    <span>{{ item.team_type_text }}</span>
                  </div>
                  <div class="carddesc">
                    <span>人数：</span>
                    <span>{{ item.team_number }}</span>
                  </div>
                  <div class="carddesc">
                    <span>性别：</span>
                    <span>{{ item.gender_text }}</span>
                  </div>
                  <div class="carddesc">
                    <span>年龄：</span>
                    <span>{{ item.age_text }}</span>
                  </div>
                  <div class="carddesc">
                    <span>职级：</span>
                    <span>{{ item.guide_rank_text }}</span>
                  </div>
                  <div class="carddesc">
                    <span>语种：</span>
                    <span>{{ item.lang_text }}</span>
                  </div>
                  <div class="carddesc">
                    <span>价格：</span>
                    <span>{{ item.total_price }}</span>
                  </div>
                  <div class="carddesc">
                    <span>擅长：</span>
                    <span>{{ item.skill_text }}</span>
                  </div>
                </div>
              </template>
              <template #footer>
                <div style="margin-top: 10px;">
                  <van-button style="border-radius: 4px;" size="small" type="info"
                    @click="goAccept(item.id)">接单</van-button>
                  <van-button style="border-radius: 4px;" size="small" type="primary"
                    @click="goDetail(item.id)">详情</van-button>
                </div>
              </template>
            </van-card>
          </div>
        </van-list>
      </div>
    </cube-page>
  </div>
</template>

<script>
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import {
  Toast,
} from 'vant';
export default {
  components: {
    CubePage
  },
  data() {
    return {
      gcfg: [],
      guideData: null,
      loading: false,
      OrderList: [],
      TourNum: 0
    }
  },
  created() {
    this.getData()
    this.gcfg = this.$store.getters.getGcfg
  },
  methods: {
    //  跳转订单
    goOrder(v) {
      this.$router.push({
        path: '/guideTravelOrder',
        query: {
          showType: v
        }
      })
    },
    // 跳转到旅导一家
    gotoTravel() {
      this.$router.push({
        path: '/guideTravel'
      })
    },
    //设置页面
    goSettingPage() {
      this.$router.push({
        path: '/guideApply',
      })
    },
    // 获取数据
    getData() {
      var url = "/addons/litestore/api.guide/index"
      //这里直接调用网络接口
      util.get(url, {}, (res) => {
        if (res.code == 1) {
          this.guideData = res.data.guide;
          this.OrderList = res.data.list;
          this.TourNum = res.data.tour_total;
        }
      });
    },
    // 接单
    goAccept(id) {
      this.$dialog.confirm({
        title: '提示',
        message: '确认进行接单操作吗？'
      }).then(() => {
        let url = '/addons/litestore/api.guide/accept';
        util.post(url, { id }, (result) => {
          if (result.code == 1 || result.code == 2002) {
            Toast(result.msg)
            let path = '/guideTravelOrder';
            if (result.code == 2002) {
              path = '/guideApply'
            }
            setTimeout(() => {
              //跳转至订单
              this.$router.push({
                path,
              })
            }, 1000);
          }
        });
      }).catch(() => { });
    },
    // 跳转到详情页面
    goDetail(id) {
      this.$router.push({
        path: '/guideTravelDetail',
        query: {
          id: id,
        }
      })
    },
  },
  watch: {
    "$store.state.gcfg"() {
      this.gcfg = this.$store.getters.getGcfg
    }
  }
}
</script>
<style>
.van-grid-item__content,
.van-cell {
  background: transparent;
  border: none;
}

/* 添加这段样式后，Primary Button 会变成红色 */
:root {
  --van-grid-item-text-color: gcfg.TopTextColor;
}
</style>
<style lang="less" scoped="scoped">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");

.setting-shop {
  position: relative;
  height: auto;
  padding-bottom: 5px;

  .field-shopxx {
    height: 100px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .dditem {
      span:first-child {
        color: rgb(255, 0, 0);
        font-weight: 600;
      }
    }
  }
}

.shop-name .name-p {
  margin-bottom: 10px;
  font-weight: bold;
}

.grid-box {
  background: #fff;
  border-radius: 5px;
  margin: 15px 0;
  box-shadow: 0 0 5px #e2e2e2;
}

.no-ddbox {
  padding-bottom: 10px;
  margin: 10px 10px 0;
}


.text-content {
  font-size: 12px;
  color: #333;
  margin-bottom: 5px;
}

.text-content {
  font-size: 14px;
  color: #333;
  padding: 0;
}

/deep/ .van-swipe {
  margin: 0;
  padding: 0;
  height: 90px;
  overflow: hidden;
}

/deep/ .van-swipe__indicator {
  background-color: #333;
}

.leoshop-content {
  margin-top: 15px;
}

.shop-xq-a {
  padding-left: 15px;
}

/deep/ .carflex {
  flex-flow: wrap;

  .carddesc {
    width: 50%;
  }
}

.van-grid-item {
  position: relative;

  .badge {
    position: absolute;
    top: 5px;
    left: 50%;
    margin-left: 5px;
    font-size: 12px;
    text-align: center;
    background-color: #ee0a24;
    border: 1px solid #fff;
    border-radius: 16px;
    color: #fff;
    min-width: 16px;
    padding: 0 3px;
  }
}
</style>
